module.exports = __webpack_public_path__ + "img/slider_tagesklinik.036cf0f0.svg";